/**
 * Contract for Config
 */
export interface IConfig {
    text: {
        hasGroup: boolean;
        hasTemplate: boolean;
    };
    quantity: {
        hasGroup: boolean;
        showDispatching: boolean;
        hasRoom: boolean;
        hasTraveller: boolean;
    };
    address: {
        hasGroup: boolean;
        showMap: boolean;
        hasTemplate?: boolean;
    };
    segment: {
        context: string;
        hasGroup: boolean;
        optionsMultiselect: { label: string; value: any }[];
        disableDates: boolean;
        night: number;
    };
    rooming: {
        hasGroup: boolean;
        hasTemplate: boolean;
    };
    keyword: {
        hasGroup: boolean;
        hasTemplate: boolean;
        hasControl: boolean;
    };
    city: {
        hasGroup: boolean;
        hasTemplate: boolean;
        hasControl: boolean;
    };
    advancedFilters: {
        hasGroup: boolean;
        hasTemplate: boolean;
        hasControl: boolean;
    };
    rating: {
        hasGroup: boolean;
        hasTemplate: boolean;
        hasControl: boolean;
    };
    referencedHotel: {
        hasGroup: boolean;
        hasTemplate: boolean;
        hasControl: boolean;
    };
    age: {
        hasGroup: boolean;
        hasTemplate: boolean;
    };
}

/**
 * Config Model
 * If we add fieldset we to define it here
 */
export class Config implements IConfig {
    public text = { hasGroup: false, hasTemplate: true };
    public address = { hasGroup: false, showMap: false };
    public segment = {
        context: 'hotel',
        hasGroup: true,
        optionsMultiselect: [{ label: 'test', value: 'test' }],
        disableDates: false,
        night: 1
    };
    public quantity = { hasGroup: true, showDispatching: false, hasRoom: true, hasTraveller: true };
    public rooming = { hasGroup: true, hasTemplate: true };
    public age = { hasGroup: true, hasTemplate: false };
    public child = { hasGroup: true, hasTemplate: false };
    public infant = { hasGroup: true, hasTemplate: false };
    public city = { hasGroup: false, hasTemplate: true, hasControl: true };
    public filters = { hasGroup: false, hasTemplate: true, hasControl: false };
    public host = { hasGroup: false, hasTemplate: true, hasControl: true };
    public rating = { hasGroup: false, hasTemplate: true, hasControl: true };
    public referencedHotel = { hasGroup: false, hasTemplate: true, hasControl: true };
    public advancedFilters = { hasGroup: false, hasTemplate: true, hasControl: false };
    public keyword = { hasGroup: false, hasTemplate: true, hasControl: true };
    public map = { hasGroup: false, hasTemplate: true, hasControl: false };
}
